<template>
    <!-- eslint-disable max-len -->
    <div class="faq-wrapper">
        <div class="faqBG">
            <div class="faq-header-container">
                <div class="faq-header-container__text">
                    <h1>Najczęściej zadawane pytania</h1>
                </div>
                <div class="faq-header-container__img"></div>
            </div>
            <div class="knowledge">
                <p v-if="isMobile()">Chcesz się dowiedzieć więcej o przerwach w dostawie energii elektrycznej?</p>
                <p v-else>Chcesz się dowiedzieć więcej o przerwach w dostawie energii elektrycznej? Sprawdź </p>
                <a href="https://stoen.pl/pl/strona/wylaczenia-planowane-i-awarie"
                   class="knowledge-button" target="_blank">
                    <i class="pi pi-arrow-right knowledge-button-icon" />
                    <span class="hover-underline">Najważniejsze informacje o wyłączeniach</span>
                </a>
            </div>
            <section class="faq-body">
                <EonList :FAQList="true" :arrowIcons="true"/>
            </section>
        </div>
    </div>
    <!-- eslint-enable max-len -->
</template>

<script>
    import {isMobile} from "@tenrok/vue3-device-detect";
    import EonList from "@/components/form/EonList";

    export default {

        data() {
            return {
            };
        },

        beforeMount() {
        },

        methods: {
            isMobile() {
                return isMobile;
            },
        },

        components: {
            EonList,
        },
    };
</script>

<style lang="less" scoped>
@import "@/assets/theme/variable.less";
.faq-wrapper {
    .faqBG {
        margin-bottom: 100px;
        .faq-header-container {
            width: 100%;
            height: 380px;
            display: flex;

            @media screen and (max-width: 700px) {
                height: auto;
            }

            &__text {
                background-color: @secondary-color;
                width: 48%;
                padding: 50px 100px 50px 140px;
                display: flex;
                align-items: center;
                justify-content: center;
                @media screen and (max-width: 700px) {
                    width: 100%;
                    padding: 50px 20px;
                }
                h1 {
                    color: white;
                    font-size: 5rem;
                    font-weight: 900;
                    text-align: right;
                    @media screen and (max-width: 1130px) {
                        font-size: 3.75rem;
                    }
                    @media screen and (max-width: 940px) {
                        font-size: 3.125rem;
                        margin: 0;
                    }
                    @media screen and (max-width: 700px) {
                        font-size: 3.75rem;
                    }
                    @media screen and (max-width: 450px) {
                        font-size: 1.875rem;
                        text-align: left;
                    }
                }
            }
            &__img {
                width: 52%;
                background-image: url("../../assets/faqViewBG.jpeg");
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                @media screen and (max-width: 700px) {
                    display: none;
                }
            }
        }
        .faq-body {
            display: flex;
            justify-content: center;
            width: 100%;
        }
    }
}
html[data-font-size='2'] {
    .faq-wrapper {
        .faqBG {
            .faq-header-container {
                height: 680px;
                h1 {
                    margin-top: 0;
                }
            }
        }
    }
}
</style>

<style lang="less">
@import "@/assets/theme/variable.less";
.faq-wrapper {
    padding-top: 3.75rem;
    .faqBG {
        .faq-body {
            .pi.sublist, .sublist-label {
                color: @color-turquoise-dark;
                font-size: 2rem;

                @media screen and (max-width: 700px) {
                    font-size: 1.25rem;
                }
            }
            .sublist-description {
                margin-top: 60px;

                @media screen and (max-width: 700px) {
                    margin-top: 30px;
                }

                ul {
                    padding-left: 20px;
                }
            }
            .faq-list {
                @media screen and (max-width: 700px) {
                    margin-right: 20px;
                    .sublist-header-button label {
                        text-align: left;
                    }
                }
            }
        }
    }
    .knowledge {
        color: black;
        //color: @color-white;
        //background-color: @color-turquoise-dark;
        width: 84%;
        border: none;
        font-size: 1.375rem;
        font-weight: bold;
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 60px 8% 60px 8%;
        @media screen and (max-width: 1390px) {
            font-size: 1.125rem;
        }

        @media screen and (max-width: 700px) {
            width: 100%;
            font-size: 1.125rem;
            flex-direction: column;
            margin: 15px 0 60px 0;
            text-align: center;
        }

        &-button {
            //color: @color-white;
            color: @color-turquoise-dark;
            font-size: 1.375rem;
            font-weight: bold;
            display: block;
            text-align: center;

            @media screen and (max-width: 700px) {
                font-size: 1rem;
            }

            @media screen and (max-width: 700px) {
                margin-right: 18px;
            }

            &-icon {
                font-size: 1.375rem;
                font-weight: bold;
                margin-right: 20px;
                margin-left: 20px;
                @media screen and (max-width: 1390px) {
                    font-size: 1.125rem;
                }

                @media screen and (max-width: 700px) {
                    font-size: 0.875rem;
                }
            }
        }
        .hover-underline:hover {
            text-decoration: underline;
        }
    }
}
</style>
